export const utilityBarConsts = {
  SEARCH_FIELD_NAME: "searchField",
  SEARCH_PLACEHOLDER: "Search",
  ADD_CUSTOMER_BTN: "+ Customer",
  SEARCH_ICON_ALT: "Click to search",
  SYNC_FROM_QUICKBOOKS: "Sync from QuickBooks",
};
